import { render } from "./FrameProcessEntry.vue?vue&type=template&id=3ee1959e&scoped=true"
import script from "./FrameProcessEntry.vue?vue&type=script&lang=js"
export * from "./FrameProcessEntry.vue?vue&type=script&lang=js"

import "./FrameProcessEntry.vue?vue&type=style&index=0&id=3ee1959e&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee1959e"]])

export default __exports__